export const UPDATE_DECLARATION_FORM_STATE_SUCCESS = "UPDATE_DECLARATION_FORM_STATE_SUCCESS";
export const UPDATE_DECLARATION_FORM_STATE_REQUEST = "UPDATE_DECLARATION_FORM_STATE_REQUEST";
export const UPDATE_DECLARATION_FORM_STATE_FAILURE = "UPDATE_DECLARATION_FORM_STATE_FAILURE";
export const UPDATE_DECLARATION_FORM_STATE_RESET = "UPDATE_DECLARATION_FORM_STATE_RESET";
export const updateDeclarationFormstateSuccess = (payload) => ({
    type: UPDATE_DECLARATION_FORM_STATE_SUCCESS,
    payload,
});
export const updateDeclarationFormstateRequest = (payload) => ({
    type: UPDATE_DECLARATION_FORM_STATE_REQUEST,
    payload,
});
export const updateDeclarationFormstateFailure = (payload) => ({
    type: UPDATE_DECLARATION_FORM_STATE_FAILURE,
    payload,
});
export const updateDeclarationFormstateReset = () => ({
    type: UPDATE_DECLARATION_FORM_STATE_RESET,
});
